import { createContext, useContext, useState } from "react";

export const UserPaymentContext = createContext();
export const UserPaymentProvider = ({ children }) => {

    // this is the data we need to fetch in payment method
    const [rowDetails, setRowDetails] = useState({
        // offers
        courseId: '',
        courseOfferId: '',
        courseOfferPrice: '',

        // training-courses
        discount: '',
        thisUserId: '',
        thisCompanyId: '',
        courseRegistrationId: '',
        userToken: '',
        thisRowPrice: '',
        theImgUploaded: '',

        // course fees
        courseFeeId: '',
        courseFeePrice: ''
    });

    // this is for payment and the design of the box in card route
    const [selectedPayment, setSelectedPayment] = useState({
        location: '', // where's course place ex: (الرياض / السعوديه)
        currencyTitle: '', // currency title (SAR || ﷼)
        date: '', // date of course
        duration: '', // duration in days
        payment: '', // payment selection
        paymentInAr: '',
    });

    return (
        <UserPaymentContext.Provider value={{ selectedPayment, setSelectedPayment, rowDetails, setRowDetails }}>
            {children}
        </UserPaymentContext.Provider>
    )
};
export const useUserSelection = () => useContext(UserPaymentContext);
